import { ThemeUICSSObject } from '@apia/theme';
import modal from './modal';
import tree from './tree';
/* IMPORT HERE */

const hierarchicalStructure: ThemeUICSSObject = {
  modal,
  tree,
  /* PREPEND HERE */
};

export default hierarchicalStructure;
